import React, { useEffect, useRef, useState } from 'react';
import { Flexbox } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import './DropdownFilter.scss';

const DropdownFilter = ({ heading, children, contentClassName, selected, onRemove }) => {
  const [showContent, setShowContent] = useState(false);
  const dropdownRef = useRef(null);

  function handleShowContent() {
    setShowContent(prev => !prev);
  }

  function handleRemove(event) {
    event.stopPropagation();
    onRemove?.();
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowContent(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className='dropdownfilter_wrapper'>
      <Flexbox gap='0.4rem' onClick={handleShowContent}>
        <ThemedText.P color='color-xlight' weight='semi-bold'>{heading}</ThemedText.P>
        {selected ? <ThemeLogo icon={'dropdownCross'} onClick={handleRemove} /> : <ThemeLogo icon={'dropdownDownArrow'} />}
      </Flexbox>
      {showContent && (
        <div className={`dropdownfilter_content ${contentClassName}`} onClick={handleShowContent}>
          {React.isValidElement(children) ? React.cloneElement(children, { onSelect: handleShowContent }) : children}
        </div>
      )}
    </div>
  );
};

export default DropdownFilter;
